<template>
  <CustDialogBox
    @closed="dialogOnCloseFn"
    :show="isShow"
    title="提示"
    width="600"
    :show-overflow-tooltip="true"
  >
    <template #content>
      <div style="margin: 10px 0">
        <el-row class="header-play"> 药品库存效期预警 </el-row>
        <CustTable
          :dataList="data"
          :header-list="tableHeader"
          style="height: 300px"
          :overflow-tooltip="true"
        >
          <template #title="scoped">
            <span class="title-play">
              {{ scoped.row.reason ?? '' }}
            </span>
          </template>
        </CustTable>
      </div>
    </template>
    <template #footer>
      <el-row style="margin-bottom: 10px; justify-content: space-between">
        <span>
          <el-button @click="dialogDayCloseFn"> 今日不再提醒 </el-button>
        </span>
        <div>
          <el-button type="primary" @click="buildCigouFn" :loading="loading">
            生成采购单
          </el-button>
          <el-button type="primary" @click="dialogOnCloseFn"> 关闭 </el-button>
        </div>
      </el-row>
    </template>
  </CustDialogBox>
</template>

<script setup>
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { instructionsPage } from '@/api/outpatients/inquiryDetail'
import { warnPurchase } from '@/api/inventory/caigou'
import { STORAGE_KEYS, useCache } from '@/libs/utils/constants'
const { wsCache } = useCache('localStorage')
const router = useRouter()
const emit = defineEmits(['update:isShow', 'submit'])
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  data: {
    type: Object,
    default: {},
  },
  settingDetail: {
    type: Object,
    default: {},
  },
})
const tableHeader = ref([
  {
    label: '药品名称',
    property: 'name',
  },
  {
    label: '药品类型',
    property: 'categoryLevel2Name',
  },
  {
    label: '库存',
    property: 'availableStock',
    formatter: row => {
      if (row.availableStock < 0) {
        return `0 ${row.unit ?? ''}`
      }
      return `${row.availableStock ?? 0} ${row.unit ?? ''}`
    },
  },
  {
    label: '效期',
    property: 'expiryDate',
    width: 110,
  },
  {
    label: '原因',
    property: 'title',
    width: 150,
    useSlot: true,
  },
])
const dialogOnCloseFn = () => {
  emit('update:isShow', false)
}
const dialogDayCloseFn = () => {
  const today = new Date().toDateString()
  wsCache.set('drugDialogClosedDate', today)
  emit('update:isShow', false)
}
const loading = ref(false)
const buildCigouFn = () => {
  loading.value = true
  warnPurchase({
    id: props.settingDetail.id,
  })
    .then(res => {
      loading.value = false
      emit('update:isShow', false)
      router.push({
        name: '/inventory',
        query: {
          tab: 'Caigou',
        },
      })
    })
    .catch(() => {
      loading.value = false
    })
}
const setpFn = () => {
  emit('update:isShow', false)
  emit('submit')
}
</script>

<style lang="scss" scoped>
.header-play {
  color: var(--dep-red);
  margin-bottom: 5px;
}
.title-play {
  color: var(--dep-red);
}
.warning-icon {
  margin-left: 5px;
  font-size: var(--font-size-middle);
  color: var(--red);
}
</style>
